import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL } from "../../config/serverApiConfig";
import styles from "./styles.module.css";
import start1 from "../../assets/imgs/start1.png";
import { useLocation } from "react-router-dom";

function LandingPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const viewMode = queryParams.get("view");

  const viewClass =
    viewMode === "mobile"
      ? styles.mobileView
      : viewMode === "tablet"
        ? styles.tabletView
        : "";

  // State to store data from API
  const [header, setHeader] = useState("");
  const [content, setContent] = useState("");
  const [offers, setOffers] = useState([]);
  const [cta, setCta] = useState("");
  const [imageFile, setImageFile] = useState("");
  const [lastSegment, setLastSegment] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [showWarning, setShowWarning] = useState(false);

  // NEW: State for incorrect user
  const [isIncorrectUser, setIsIncorrectUser] = useState(false);

  // NEW: State for department disabled status
  const [isDisabled, setIsDisabled] = useState(false);

  // Automatically remove token after 1 second (if present)
  // Load data from server
  useEffect(() => {
    const pathname = window.location.pathname;
    const segments = pathname.split("/");
    let segment = segments[segments.length - 1];

    // Set DefaultPage to true if no company code in URL; else false.
    setLastSegment(segment);

    // If local storage has 'reg' and it's different from the current segment,
    // reset the relevant local storage items
    if (
      localStorage.getItem("reg") &&
      localStorage.getItem("reg") !== segment
    ) {
      localStorage.removeItem("patnerImg");
      localStorage.removeItem("partnerurl");
      localStorage.removeItem("companyname");
      localStorage.removeItem("reg");
    }

    axios
      .post(API_BASE_URL + "/sb_getlandingpage", {
        usercode: segment ? segment : "",
      })
      .then((response) => {
        // Check for incorrect user
        if (
          response.data.Message &&
          response.data.Message === "Incorrect User "
        ) {
          localStorage.removeItem("patnerImg");
          localStorage.removeItem("partnerurl");
          localStorage.removeItem("companyname");
          localStorage.removeItem("reg");
          setIsIncorrectUser(true);
        }
        // Otherwise, proceed if we have valid user data
        else if (
          response.data.user_data &&
          response.data.user_data.length > 0
        ) {
          const userData = response.data.user_data[0];
          console.log("userData = ", userData);
          setHeader(userData.adminpageheader);
          setContent(userData.adminpagecontent);
          // setOffers(userData.aadminpageoffers);

          if (userData?.aadminpageoffers) {
            const rawOffers = userData.aadminpageoffers;

            const parsedOffers = Array.isArray(rawOffers)
              ? rawOffers
              : typeof rawOffers === "string"
                ? rawOffers.split(",").map((str) => str.trim())
                : [];

            setOffers(parsedOffers);
          }
          setCta(userData.adminpagecta);
          setImageFile(userData.imageFile);

          // Remove existing partner items
          localStorage.removeItem("patnerImg");
          localStorage.removeItem("partnerurl");
          localStorage.removeItem("companyname");

          // Set new items from API
          localStorage.setItem("patnerImg", userData.imageFile);
          localStorage.setItem("partnerurl", userData.admin_site_url);
          localStorage.setItem("companyname", userData.companyname);

          // IMPORTANT: set 'reg' from the admincode in the API response
          localStorage.setItem("reg", userData.admincode);

          // NEW: Check the deptstatus to determine if the department is disabled
          if (userData.deptstatus === 0) {
            setIsDisabled(true);
          } else {
            setIsDisabled(false);
          }

          setTimeout(logout, 1000);
          setIsIncorrectUser(false);
        }
        // If for some reason user_data is empty but no 'Incorrect User' message
        else {
          localStorage.removeItem("patnerImg");
          localStorage.removeItem("partnerurl");
          localStorage.removeItem("companyname");
          localStorage.removeItem("reg");
          setIsIncorrectUser(true);
        }
      })
      .catch((error) => {
        console.error(error);
        localStorage.removeItem("patnerImg");
        localStorage.removeItem("partnerurl");
        localStorage.removeItem("companyname");
        localStorage.removeItem("reg");
        setIsIncorrectUser(true);
      });
  }, []);

  // Hide logout link after data load
  const logout = () => {
    const el = document.getElementById("logout1");
    if (el) el.innerHTML = "";
  };

  useEffect(() => {
    setTimeout(logout, 1000);
  }, [header, content, offers, cta, imageFile]);

  // Check if mobile
  const isMobileView = () => window.innerWidth <= 768;

  console.log("offers - ", offers);
  const user1 = localStorage.getItem("token1");

  const handleStartClick = () => {
    // if (!isChecked) {
    //   setShowWarning(true);
    //   return;
    // }

    setShowWarning(false);

    if (user1) {
      navigate("/user-landingpage/Assessment");
    } else {
      navigate("/user-register");
    }
  };

  return (
    <>
      {/* If user is incorrect, show the modal overlay and blur background */}
      {isIncorrectUser && (
        <div className={styles.modalOverlay}>
          <div className={styles.modalContent}>
            <h2>Incorrect URL</h2>
            <p>Please check your URL.</p>
          </div>
        </div>
      )}

      {/* NEW: Show modal if the department is disabled by the admin */}
      {isDisabled && (
        <div className={styles.modalOverlay}>
          <div className={styles.modalContent}>
            <h2>Department Disabled</h2>
            <p>This department has been disabled by the admin.</p>
          </div>
        </div>
      )}

      {/* Blur the main content if modal is open */}
      <div
        className={isIncorrectUser || isDisabled ? styles.blurBackground : ""}
      >
        {/* <div className={styles.landingContainer}> */}
        <div className={`${styles.landingContainer} ${viewClass}`}>
          {/* Register / Login buttons */}
          {!user1 && (
            <div className={styles.buttonGroup}>
              <Link to="/user-register" className={styles.btnRegister}>
                Register
              </Link>
              <Link to="/user-login" className={styles.btnLogin}>
                Login
              </Link>
            </div>
          )}

          {/* Heading (with image from API, if any) */}
          <header className={styles.pageHeader}>
            {imageFile && (
              <div className={styles.imageContainer}>
                <img
                  className={styles.apiImage}
                  src={`https://starbehaviors.com/uploadimage/${imageFile}`}
                  alt="Partner from API"
                />
              </div>
            )}

            <h1 className={styles.mainHeading}>
              {header || "Welcome to Our Landing Page"}
            </h1>

            {/* {isMobileView() && (
              <p style={{ backgroundColor: '#003366', padding: '0.4rem', borderRadius: '8px', marginTop: '15px' }}>
                <strong>
                  {
                    user1 ? (<Link to="/user" className={styles.finalCtaButton}>
                      Start by Completing our Online Assessment and Application Today!
                    </Link>) : (<Link to="/user-register" className={styles.finalCtaButton}>
                      Start by Completing our Online Assessment and Application Today!
                    </Link>)
                  }
                </strong>
              </p>
            )} */}
          </header>

          {/* What We Offer */}
          <section className={styles.offersSection}>
            <div className={styles.offersContainer}>
              <h2 className={styles.sectionTitle}>What Do We Offer?</h2>
              <ul className={styles.offeringList}>
                {offers?.length > 0 ? (
                  offers?.map((offer, index) => (
                    <li key={index} className={styles.offerItem}>
                      <div className={""}>
                        <img
                          src={"https://starbehaviors.com/uploadimage/5.png"}
                          alt="Star"
                        />
                        {/* <img
                          src={start1}
                          alt="Star"
                        /> */}
                      </div>
                      <p>{offer.trim()}</p>
                    </li>
                  ))
                ) : (
                  <li className={styles.offerItem}>
                    <p>No offerings to display</p>
                  </li>
                )}
              </ul>
            </div>
          </section>

          {/* Main Content */}
          <section className={styles.contentSection}>
            <div
              className={styles.richContent}
              dangerouslySetInnerHTML={{ __html: content }}
            />
            <div className={styles.finalCta}>
              <p className={styles.finalCtaText}>
                <strong>{cta}</strong>
              </p>

              {/* <div
                style={{
                  marginBottom: "10px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <label style={{ fontSize: "14px" }}>
                  <input
                    type="checkbox"
                    checked={isChecked}
                    onChange={(e) => {
                      setIsChecked(e.target.checked);
                      setShowWarning(false);
                    }}
                    style={{ marginRight: "8px" }}
                  />
                </label>
                I agree to the Terms & Conditions
              </div> */}

              <p
                style={{
                  backgroundColor: "#003366",
                  padding: "0.4rem",
                  borderRadius: "8px",
                }}
              >
                <strong>
                  <button
                    onClick={handleStartClick}
                    className={styles.finalCtaButton}
                    style={{
                      background: "transparent",
                      border: "none",
                      color: "#fff",
                      cursor: "pointer",
                    }}
                  >
                    Start by Completing our Online Assessment and Application
                    Today!
                  </button>
                </strong>
              </p>

              {/* Warning Message */}
              {/* {showWarning && (
                <p style={{ color: "red", fontSize: "14px", marginTop: "8px" }}>
                  ⚠ Please check the Terms & Conditions before proceeding.
                </p>
              )} */}
            </div>
          </section>

          {/* Simple Footer */}
          <footer className={styles.footerSection}>
            <p>
              Copyright &copy; {new Date().getFullYear()} - All Rights Reserved.
            </p>
          </footer>
        </div>
      </div>
    </>
  );
}

export default LandingPage;
